import { render } from "./StatusTroca.vue?vue&type=template&id=3d242f31&scoped=true"
import script from "./StatusTroca.vue?vue&type=script&lang=js"
export * from "./StatusTroca.vue?vue&type=script&lang=js"

import "./StatusTroca.vue?vue&type=style&index=0&id=3d242f31&lang=css"
import "./StatusTroca.vue?vue&type=style&index=1&id=3d242f31&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d242f31"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QSelect,QInput,QImg,QPagination,QField});
